module.exports = __webpack_public_path__ + "media/images/individual-benefit-2-c1732d595c4d1aef5b345c9f7daeaa8f.svg";